import { RootState } from "redux/store";
import { Table, TooltipIcon } from "components";
import { Col, Row } from "react-bootstrap";
import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { showToast } from "redux/slices/Toasts";
import { getSupplierNameMappingDetails, deleteSupplierNameMapping, createSupplierNameMapping, updateSupplierNameMappingField } from "redux/slices/SupplierNameMappings";

type SupplierNameMappingGridProps = {
    supplierId: number;
}

export function SupplierNameMappingGrid(props: SupplierNameMappingGridProps) {
    const dispatch = useAppDispatch();
    const supplierNameMappings = useAppSelector((state: RootState) => state.supplierNameMappings);
    const columns = [
        {
            Header: "Name",
            accessor: "alternateName",
            defaultCanSort: true,
            width: 500,
            Cell: (row: any) => <>{row.value}</>,
        }
    ];

    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            //setValue(value);
            //event.preventDefault();
            handleAddSupplierNameMapping(altName);
        }
    };

    const [altName, setAltName] = useState<string>("");

    const selectedRows = useCallback((pageIndex: any) => {
        dispatch(updateSupplierNameMappingField({ key: "selectedRows", value: pageIndex }));
    }, []);

    function handleDeleteSupplierNameMapping() {
        supplierNameMappings.selectedRows.forEach((row: any) => {
            // @ts-ignore
            let altName = supplierNameMappings.table[parseInt(row)].alternateName;
            dispatch(deleteSupplierNameMapping({
                alternateNames: [altName],
                ids: [props.supplierId]
            }
            )).then(() => {
                dispatch(getSupplierNameMappingDetails(props.supplierId));
            });
        });
    }

    async function handleAddSupplierNameMapping(name: any) {
        let createAltNameResponse = await dispatch(createSupplierNameMapping({
            alternateName: name,
            supplierId: props.supplierId
        }));

        dispatch(getSupplierNameMappingDetails(props.supplierId));
        setAltName("");
    }

    return (
        <>
            <Row>
                <Col xs={12} className="d-inline-flex align-items-center">
                    <h5 className="mb-0">Alternate Names</h5>
                    <TooltipIcon text={"Used for supplier matching in the import wizard"} placement="right" icon="mdi-information" classes={["mdi"]} />
                </Col>
            </Row>

            <Table maxHeight={200}         
                isSortable={true}
                pagination={false}
                isSelectable={true}
                disableExport={true}
                columns={columns}
                isSearchable={false}
                data={supplierNameMappings.table}
                selectedRows={selectedRows}
                loading={supplierNameMappings.loading}
                removeRows={handleDeleteSupplierNameMapping}
                onQuickAdd={handleAddSupplierNameMapping}
                allowQuickAdd={true}
                reloadTableRows={() => dispatch(getSupplierNameMappingDetails(props.supplierId))}
            />
        </>
    )
}